(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const main = document.querySelector('#MainContent');
  const headerGroup = document.querySelector('#header-group');

  /* Private Access brand lock.
     Position the monogram in the visual gap between the two campaign models
     and force MAISON VYNCE to sit directly underneath it on every phone size. */
  const privateAccessRoot = document.querySelector('.mv-pa');
  if (privateAccessRoot && !document.querySelector('#mv-private-access-brand-lock')) {
    const brandStyle = document.createElement('style');
    brandStyle.id = 'mv-private-access-brand-lock';
    brandStyle.textContent = `
      body:has(.mv-pa) .mv-pa__brand {
        left: 52.5% !important;
        top: 62px !important;
        transform: translateX(-50%) !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 4px !important;
        width: max-content !important;
        min-height: 0 !important;
        padding: 0 !important;
        text-align: center !important;
        white-space: nowrap !important;
      }
      body:has(.mv-pa) .mv-pa__mark {
        display: block !important;
        width: 44px !important;
        height: 31px !important;
        margin: 0 auto !important;
        object-fit: contain !important;
        object-position: center !important;
      }
      body:has(.mv-pa) .mv-pa__brand-name {
        display: block !important;
        margin: 0 !important;
        padding: 0 !important;
        width: max-content !important;
        font-size: 8px !important;
        line-height: 1 !important;
        letter-spacing: .23em !important;
        text-align: center !important;
      }
      @media (max-width: 749px) {
        body:has(.mv-pa) .mv-pa__brand {
          left: 54% !important;
          top: 60px !important;
          gap: 4px !important;
        }
        body:has(.mv-pa) .mv-pa__mark {
          width: 42px !important;
          height: 30px !important;
        }
        body:has(.mv-pa) .mv-pa__brand-name {
          font-size: 7.7px !important;
          letter-spacing: .22em !important;
        }
      }
      @media (max-width: 390px) {
        body:has(.mv-pa) .mv-pa__brand {
          left: 54% !important;
          top: 58px !important;
        }
        body:has(.mv-pa) .mv-pa__brand-name {
          font-size: 7.4px !important;
        }
      }
      @media (max-width: 749px) and (max-height: 720px) {
        body:has(.mv-pa) .mv-pa__brand {
          top: 52px !important;
        }
      }
    `;
    document.head.appendChild(brandStyle);
  }

  const updateHeader = () => {
    headerGroup?.classList.toggle('mv-header-scrolled', window.scrollY > 18);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  /* PRIVATE ACCESS
     Give immediate visual confirmation before Shopify performs the native
     customer-form POST. The UI never claims that an email was sent because
     that delivery is controlled separately by Shopify's double-opt-in system. */
  const privateAccessForm = document.querySelector('#MVPrivateAccessForm');
  if (privateAccessForm) {
    privateAccessForm.dataset.mvPrivateAccessBound = 'true';

    const serverSuccess = privateAccessForm.querySelector('.mv-pa__success');
    const currentUrl = new URL(window.location.href);
    const returnedFromSubmit = currentUrl.searchParams.get('mv_access') === '1';

    const setSuccessCopy = (node) => {
      if (!node) return;
      const title = node.querySelector('strong');
      const copy = node.querySelector('span');
      if (title) title.textContent = 'ACCESS REQUEST RECEIVED.';
      if (copy) copy.textContent = "You're on the Maison Vynce private list.";
    };

    const animateSuccess = (node) => {
      if (!node || reducedMotion) return;
      node.animate(
        [
          { opacity: 0, transform: 'translateY(12px) scale(.985)' },
          { opacity: 1, transform: 'translateY(0) scale(1)' }
        ],
        { duration: 720, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }
      );
    };

    const showLocalSuccess = () => {
      let success = privateAccessForm.querySelector('.mv-pa__success--client');
      if (!success) {
        success = document.createElement('div');
        success.className = 'mv-pa__success mv-pa__success--client';
        success.setAttribute('role', 'status');
        success.setAttribute('aria-live', 'polite');
        success.innerHTML = '<strong>ACCESS REQUEST RECEIVED.</strong><span>You\'re on the Maison Vynce private list.</span>';

        const fieldRow = privateAccessForm.querySelector('.mv-pa__field-row');
        const consent = privateAccessForm.querySelector('.mv-pa__consent');
        const error = privateAccessForm.querySelector('.mv-pa__error');

        if (fieldRow) fieldRow.hidden = true;
        if (consent) consent.hidden = true;
        if (error) error.hidden = true;

        const anchor = fieldRow || consent || privateAccessForm.firstElementChild;
        if (anchor?.parentNode) anchor.parentNode.insertBefore(success, anchor);
        else privateAccessForm.appendChild(success);
      }

      setSuccessCopy(success);
      animateSuccess(success);
      return success;
    };

    if (serverSuccess) {
      setSuccessCopy(serverSuccess);
      animateSuccess(serverSuccess);
    } else if (returnedFromSubmit) {
      showLocalSuccess();
    } else {
      privateAccessForm.addEventListener('submit', (event) => {
        if (!privateAccessForm.checkValidity()) return;
        event.preventDefault();

        const button = privateAccessForm.querySelector('button[type="submit"]');
        const fieldRow = privateAccessForm.querySelector('.mv-pa__field-row');
        const consent = privateAccessForm.querySelector('.mv-pa__consent');

        privateAccessForm.setAttribute('aria-busy', 'true');
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.textContent = 'REQUEST RECEIVED';
        }

        if (!reducedMotion && fieldRow) {
          fieldRow.animate(
            [
              { opacity: 1, transform: 'translateY(0)' },
              { opacity: 0, transform: 'translateY(-8px)' }
            ],
            { duration: 300, easing: 'ease', fill: 'both' }
          );
        }

        window.setTimeout(() => {
          if (fieldRow) fieldRow.hidden = true;
          if (consent) consent.hidden = true;
          showLocalSuccess();
        }, reducedMotion ? 0 : 260);

        let returnTo = privateAccessForm.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          privateAccessForm.appendChild(returnTo);
        }

        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('mv_access', '1');
        returnTo.value = `${returnUrl.pathname}${returnUrl.search}#MVPrivateAccessForm`;

        window.setTimeout(() => {
          HTMLFormElement.prototype.submit.call(privateAccessForm);
        }, reducedMotion ? 900 : 1650);
      });
    }

    if (returnedFromSubmit) {
      currentUrl.searchParams.delete('mv_access');
      const cleanUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
      window.history.replaceState({}, '', cleanUrl);
    }
  }

  /* Keep the existing “Accès privé” navigation useful even though the
     signup form lives in the global footer rather than a homepage section. */
  const accessLinks = document.querySelectorAll('a[href$="#shopify-section-newsletter_MV01"]');
  const signup = document.querySelector('footer email-signup, footer [class*="email-signup"]');
  if (signup) {
    signup.id = signup.id || 'maison-vynce-access';
    accessLinks.forEach((link) => {
      link.setAttribute('href', '#maison-vynce-access');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        signup.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => signup.querySelector('input[type="email"]')?.focus(), reducedMotion ? 0 : 650);
      });
    });
  }

  if (!main || reducedMotion) return;

  const observed = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('mv-is-visible');
      observer.unobserve(entry.target);
      window.setTimeout(() => entry.target.classList.add('mv-motion-complete'), 800);
    });
  }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });

  const enhanceImages = (root) => {
    root.querySelectorAll('img').forEach((image) => {
      if (image.closest('.shopify-section:first-child')) return;
      const wrapper = image.parentElement;
      if (!wrapper || wrapper.classList.contains('mv-motion-clip')) return;
      wrapper.classList.add('mv-motion-clip');
      image.classList.add('mv-motion-image');
    });
  };

  const enhanceSections = (root = main) => {
    const sections = [...root.querySelectorAll('.shopify-section')];
    sections.forEach((section, index) => {
      if (section === main.querySelector('.shopify-section:first-child') || observed.has(section)) return;
      observed.add(section);
      section.classList.add('mv-reveal', index % 2 ? 'mv-from-right' : 'mv-from-left');
      observer.observe(section);
      enhanceImages(section);
    });
  };

  enhanceSections();
  document.documentElement.classList.add('mv-motion-ready');

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) enhanceSections(event.target.parentElement || main);
  });

  const dynamicContent = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    enhanceSections();
    enhanceImages(main);
  });

  dynamicContent.observe(main, { childList: true, subtree: true });
})();
